export default {
    name: 'talents',
    path: '/talents',
    redirect: '/basketball-talent-pool/home',
    component: () => import('@/view/talents/Container.vue'),
    children: [
        {
            name: 'talentsHome',
            path: 'home',
            meta: {
                title: '人才库评选',
            },
            component: () => import('@/view/talents/index.vue'),
        },
        {
            name: 'talentsList',
            path: 'list',
            meta: {
                title: '人才库列表',
            },
            component: () => import('@/view/talents/list.vue'),
        },
        {
            name: 'talentsDetail',
            path: 'detail',
            meta: {
                title: '人才详情',
            },
            component: () => import('@/view/talents/detail.vue'),
        },
        {
            name: 'talentsShow',
            path: 'show',
            meta: {
                title: '人才详情',
            },
            component: () => import('@/view/talents/show.vue'),
        },
        {
            name: 'talentsReport',
            path: 'report',
            meta: {
                title: '人才详情',
            },
            component: () => import('@/view/talents/report.vue'),
        },
    ],
}
